export function isHTML(str: any) {
  return /<\/?[a-z][\s\S]*>/i.test(str);
}
